<app-notification (notificationClosed)="errorMsg=null" *ngIf="this.errorMsg != null" [content]="this.errorMsg" display="true"
                  error=true ignoreOffset="true"
                  timeOut="5000"></app-notification>
<div class="columns" style="margin-top: 2%">
  <div class="column is-1"></div>
  <div *ngIf="savedPropertyForm" class="column is-10 card has-round-border" style="margin-bottom: 15px;">
    <div class="columns" style="background-color: #35566E">
      <div class="column is-1">
          <a class="is-clickable color-white mr-4 is-vertical-middle is-size-5" routerLink="/saved-properties">
              <fa-icon [icon]="faArrowLeft"></fa-icon>
          </a>
      </div>
      <div class="column">
        <div class="title is-4 has-text-centered is-bold" style="color: white">
          Objektinformationen
        </div>
      </div>
    </div>

<!--    <div class="columns">
      <div class="column is-one-quarter" style="padding-right: 0">
        <div style="position: relative">

          <input (keydown)="inputFocus=true" (keyup)="setFoundMandates()" [(ngModel)]="searchText" class="input"
                 placeholder="Mandat suchen" style="border-radius: 15px 0 0 15px !important;height: 50px; padding: 10px;z-index: 4;border-bottom: none !important;box-shadow: 0 0.5em 1em -0.125em rgba(10,10,10,0.1), 0 0px 0 1px rgba(10,10,10,0.02) !important;"
                 type="text">

          <div *ngIf="searchText && inputFocus" class="card"
               style="position:absolute; width: 100%;z-index: 3; margin-left: 5px; margin-top: -15%;padding-top: 3rem">
            <table class="table result-table" id="result-table" style="width: 100%">
              <thead>
              <tr [ngClass]="{'is-hidden': !foundMandate || !searchText}">
                <th scope="col">Name</th>
              </tr>
              </thead>
              <tbody>
              <tr [ngClass]="{'is-hidden': foundMandate || !searchText}">
                <td colspan="3">Kein Mandat gefunden</td>
              </tr>
              <tr (click)="updateMandateIdForProperty(null)" class="is-clickable result-row">
                <td>Kein Mandat</td>
              </tr>
              <ng-container *ngIf="mandates">
                <ng-container *ngFor="let mandate of mandates | search: searchText:'mandate'">
                  <tr (click)="updateMandateIdForProperty(mandate.id)" class="is-clickable result-row">
                    <td>{{mandate.name}}</td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="column is-1" style="padding-left: 0px; margin: auto auto auto 0;">
        <button (click)="openMandateModal()" class="button buy-button is-size-7 has-round-border"
                style="border: none; height: 50px; border-radius: 0 15px 15px 0 !important; background-color: #73B1D6 !important;">
          <svg height="21.043" style="vertical-align: middle" viewBox="0 0 21.043 21.043" width="21.043"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z" data-name="Icon awesome-plus"
                  fill="#ffffff"
                  id="Icon_awesome-plus" transform="translate(0 -2.25)"/>
          </svg>
        </button>
      </div>
    </div>-->
    <form [formGroup]="savedPropertyForm" id="saved-property-form">
      <div class="columns">
        <div class="column is-one-fifth">
          <div class="inputfield">
            <div class="is-bold">ID</div>
            <input class="border-input" formControlName="ownId" type="text" value="{{savedProperty.ownId}}">
          </div>
        </div>
        <div class="column is-two-fifths">
          <div class="inputfield">
            <div class="is-bold">Name</div>
            <input class="border-input" formControlName="name" type="text" value="{{savedProperty.name}}">
          </div>
        </div>
        <div class="column is-two-fifths">
          <div class="inputfield">
            <div class="is-bold">Email</div>
            <input class="border-input" formControlName="contactMail" type="text" value="{{savedProperty.contactMail}}">
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-4">
          <div class="inputfield">
            <div class="is-bold">Straße</div>
            <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('street'))}" class="border-input" formControlName="street" type="text"
                   value="{{savedProperty.street}}">
          </div>
        </div>
        <div class="column is-2">
          <div class="inputfield">
            <div class="is-bold">Hausnummer</div>
            <input class="border-input" formControlName="house_number" type="text"
                   value="{{savedProperty.house_number}}">
          </div>
        </div>
        <div class="column is-2">
          <div class="inputfield">
            <div class="is-bold">PLZ</div>
            <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('zip'))}" class="border-input" formControlName="zip" type="text"
                   value="{{savedProperty.zip}}">
          </div>
        </div>
        <div class="column is-4">
          <div class="inputfield">
            <div class="is-bold">Stadt</div>
            <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('town'))}" class="border-input" formControlName="town" type="text"
                   value="{{savedProperty.town}}">
          </div>
        </div>
      </div>

      <hr>

      <div class="columns is-mobile" formArrayName="landregisterfolios" style="flex-wrap: wrap">
        <div *ngFor="let landregisterfolio of getFolios(savedPropertyForm); let i = index"
             [formGroupName]="i" class="column is-6-tablet is-6-desktop is-12-mobile">
          <div class="columns is-mobile">
            <div class="column is-5-tablet is-5-desktop is-6-mobile">
              <div class="inputfield">
                <div class="is-bold">Grundbuchblatt</div>
                <input [ngClass]="{'has-error': hasError(landregisterfolio.get('number'))}" class="border-input" formControlName="number" type="text"
                       value="{{landregisterfolio.number}}">
              </div>
            </div>
            <div class="column is-6-tablet is-5-desktop is-5-mobile">
              <div class="inputfield">
                <div class="is-bold">Gemarkung</div>
                <input [ngClass]="{'has-error': hasError(landregisterfolio.get('gemarkung'))}" class="border-input" formControlName="gemarkung"
                       type="text"
                       value="{{landregisterfolio.gemarkung}}">
              </div>
            </div>
            <div class="column is-1-tablet is-1-desktop is-1-mobile">
              <button (click)="deleteFolio(i)" *ngIf="i != 0" class="button fs-del-button is-white" style="margin: 0;margin-bottom: 0;padding: 0;margin-top: 5px;"
                      type="submit">
                <svg height="8" viewBox="0 0 8 8" width="8"
                     xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <style>.a {
                      fill: #e87c7f;
                    }</style>
                  </defs>
                  <path d="M4,4.727.727,8,0,7.273,3.273,4,0,.727.727,0,4,3.273,7.273,0,8,.727,4.727,4,8,7.273,7.273,8Z"
                        style="fill: red;"/>
                </svg>
              </button>
            </div>
          </div>
          <div formArrayName="flure">
            <div *ngFor="let flur of getFlure(landregisterfolio); let flurI = index" [formGroupName]="flurI"
                 class="columns is-mobile">
              <div class="column is-4-tablet is-4-desktop is-6-mobile">
                <div class="inputfield">
                  <div class="is-bold">Flur</div>
                  <div style="display:flex; flex-direction: row;">
                    <input class="border-input" formControlName="number" style="flex-grow: 2" type="text"
                           value="{{flur.number}}">
                    <button (click)="deleteFlur(i, flurI)" *ngIf="flurI != 0" class="button fs-del-button is-white"
                            style="margin: 0;padding: 0;margin-top: 7px;left: 1px;background-color: rgba(0,0,0,0.0); margin-left: -20px"
                            type="submit">
                      <svg height="8" viewBox="0 0 8 8" width="8"
                           xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <style>.a {
                            fill: #e87c7f;
                          }</style>
                        </defs>
                        <path d="M4,4.727.727,8,0,7.273,3.273,4,0,.727.727,0,4,3.273,7.273,0,8,.727,4.727,4,8,7.273,7.273,8Z"
                              style="fill: red;"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="column is-8-tablet is-8-desktop is-6-mobile">
                <div class="columns is-mobile" style="flex-wrap: wrap; width: 100%;">
                  <div *ngFor="let flurstueck of getFlurstuecke(flur), let fsI = index" class="column is-4"
                       formArrayName="flurstuecke">
                    <div class="is-bold">Flstk</div>
                    <div [formGroupName]="fsI" style="display: flex;flex-direction: row">
                      <input [ngClass]="{'has-error': hasError(flurstueck.get('number'))}" class="border-input" formControlName="number" type="text"
                             value="{{flurstueck.number}}">
                      <button (click)="deleteFlurstueck(i, flurI, fsI)" *ngIf="fsI != 0"
                              class="button fs-del-button is-white"
                              style="margin: 0;padding: 0;margin-top: 7px; left: 1px; background-color: rgba(0,0,0,0.0);margin-left: -20px"
                              type="submit">
                        <svg height="8" viewBox="0 0 8 8"
                             width="8"
                             xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <style>.a {
                              fill: #e87c7f;
                            }</style>
                          </defs>
                          <path d="M4,4.727.727,8,0,7.273,3.273,4,0,.727.727,0,4,3.273,7.273,0,8,.727,4.727,4,8,7.273,7.273,8Z"
                                style="fill: red;"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="column is-3" style="display: flex; align-items: center; justify-content: center">
                    <button (click)="addFlurstueck(i,flurI)" class="button fs-button is-white"
                            style="margin-left: 0;padding: 0" type="submit">
                                              <span class="icon is-small">
                                                <svg height="15.989" viewBox="0 0 15.989 15.989" width="15.989"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z" data-name="Icon awesome-plus"
                                                        fill="#707070"
                                                        id="Icon_awesome-plus" transform="translate(0 -2.25)"/>
                                                </svg>
                                                </span>
                      <span>
                                                Flstk.
                                              </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <button (click)="addFlur(i)" class=" fl-button button is-white"
                    type="submit">
                                  <span class="icon is-small">
                                    <svg height="15.989" viewBox="0 0 15.989 15.989" width="15.989"
                                         xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z" data-name="Icon awesome-plus"
                                            fill="#707070"
                                            id="Icon_awesome-plus" transform="translate(0 -2.25)"/>
                                    </svg>
                                  </span>
              <span>
                                    Flur
                                  </span>
            </button>
          </div>
        </div>
        <div class="column is-two-third-tablet is-12-mobile add-button-wrapper">
          <button (click)="addFolio()"
                  class="gb-button button is-white" style="text-align: left; vertical-align: top; margin-left: 0"
                  type="submit">
                    <span class="icon is-small">
                      <svg height="15.989" viewBox="0 0 15.989 15.989" width="15.989"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z" data-name="Icon awesome-plus"
                              fill="#707070"
                              id="Icon_awesome-plus" transform="translate(0 -2.25)"/>
                      </svg>
                    </span>
            <span>
                    Grundbuchblatt
                </span>
          </button>
        </div>
      </div>

      <hr>

      <div class="columns">
        <div class="column promoted-checkbox" style="display: flex; justify-content: center; align-items: center">
          <input
              [checked]="shouldBillingAddressEqualBeneficiaryAddress"
              id="beneficiary-checkbox"
              type="checkbox"
              class="promoted-input-checkbox"
              (change)="toggleBeneficiaryAddress($event)"/>

          <label for="beneficiary-checkbox" class="custom-checkbox-label">
            <img class="checkbox-icon"
                 [src]="shouldBillingAddressEqualBeneficiaryAddress? 'assets/images/checkbox/checked.svg': 'assets/images/checkbox/unchecked.svg'"
                 alt="Checkbox icon"/>
            <span>Leistungsempfänger entspricht Rechnungsempfänger</span>
          </label>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half" style="margin: auto" formGroupName="billingAddress">
          <div class="is-bold">Rechnungsempfänger</div>
          <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('billingAddress').get('firma'))}" class="border-input" formControlName="firma"
                 value="{{savedProperty.billingAddress ? savedProperty.billingAddress.firma : null}}">
          <div class="is-bold">Straße</div>
          <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('billingAddress').get('street'))}" class="border-input" formControlName="street"
                 value="{{savedProperty.billingAddress ? savedProperty.billingAddress.street : null}}">
          <div class="columns">
            <div class="column is-4">
              <div class="is-bold">PLZ</div>
              <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('billingAddress').get('zip'))}" class="border-input" formControlName="zip"
                     value="{{savedProperty.billingAddress ? savedProperty.billingAddress.zip : null}}">
            </div>
            <div class="column">
              <div class="is-bold">Stadt</div>
              <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('billingAddress').get('town'))}" class="border-input" formControlName="town"
                     value="{{savedProperty.billingAddress ? savedProperty.billingAddress.town : null}}">
            </div>
          </div>
          <div class="is-bold">Land</div>
          <div class="country-select-wrapper">
            <select class="border-input" formControlName="country">
              <option value="" disabled>Land</option>
              <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
            </select>
          </div>
        </div>
        <div *ngIf="!shouldBillingAddressEqualBeneficiaryAddress" class="column is-half" formGroupName="beneficiariesAddress">
          <div class="is-bold">Leistungsempfänger</div>
          <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('beneficiariesAddress').get('beneficiary'))}" class="border-input"
                 formControlName="beneficiary"
                 value="{{savedProperty.beneficiariesAddress ? savedProperty.beneficiariesAddress.beneficiary : null}}">
          <div class="is-bold">Straße</div>
          <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('beneficiariesAddress').get('street'))}" class="border-input" formControlName="street"
                 value="{{savedProperty.beneficiariesAddress ? savedProperty.beneficiariesAddress.street : null}}">
          <div class="columns">
            <div class="column is-4">
              <div class="is-bold">PLZ</div>
              <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('beneficiariesAddress').get('zip'))}" class="border-input" formControlName="zip"
                     value="{{savedProperty.beneficiariesAddress ? savedProperty.beneficiariesAddress.zip : null}}">
            </div>
            <div class="column">
              <div class="is-bold">Stadt</div>
              <input [ngClass]="{'has-error': hasError(savedPropertyForm.get('beneficiariesAddress').get('town'))}" class="border-input" formControlName="town"
                     value="{{savedProperty.beneficiariesAddress ? savedProperty.beneficiariesAddress.town : null}}">
            </div>
          </div>
          <div class="is-bold">Land</div>
          <div class="country-select-wrapper">
            <select class="border-input" formControlName="country">
              <option value="" disabled>Land</option>
              <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <hr>

      <div>
        <div *ngFor="let authorities of getAuthorities(savedPropertyForm); let i = index"
             class="columns card margin-auto w-50"
             style="margin: 10px;height: 50px; justify-content: center; align-items: center; display: flex">
          <div (click)="showAuthority(i)" class="column is-four-fifths is-clickable">
            <a style="color: #35566E">Vollmacht {{i + 1}}</a>
          </div>
          <div class="column is-one-fifth">
            <a (click)="removeSavedAuthority(i)" style="float: right">
              <svg height="10.085" viewBox="0 0 10.084 10.085" width="10.084" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.787,104.339a1.008,1.008,0,1,1-1.425,1.425l-3.321-3.319-3.32,3.318A1.008,1.008,0,1,1,.3,104.337l3.321-3.321L.3,97.7A1.008,1.008,0,0,1,1.721,96.27l3.32,3.323,3.321-3.321A1.008,1.008,0,1,1,9.789,97.7l-3.321,3.321Z" data-name="Pfad 619"
                      fill="red"
                      id="Pfad_619" transform="translate(0 -95.975)"/>
              </svg>
            </a>
          </div>
        </div>

        <div>
          <div class="title is-4 has-text-centered is-bold" style="color: #35566E !important; margin-top: 40px">
            Vollmacht hinzufügen
          </div>
          <div class="columns">
            <div class="column is-3"></div>
            <div class="column">
              <app-dropzone-connect #authorityDropzone [maxNumberOfFiles]="10"
                                    dropzoneImage="assets/images/dropzone/upload-icon2.svg"></app-dropzone-connect>

              <div *ngIf="savedPropertyId !== 'new'" style="margin-top: 10px">
                <div class="columns" style="flex-wrap: wrap">
                  <div class="column is-12">
                    <a (click)="updateSavedProperty(savedPropertyId)" class="button buy-button is-size-6 has-round-border"
                       style="border:none; display: block!important;">
                      <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                        <div class="column is-bold"><p style="padding-bottom: 10px">Aktualisieren</p></div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div *ngIf="savedPropertyId === 'new'" style="margin-top: 10px">
                <div class="columns" style="flex-wrap: wrap">
                  <div class="column is-12">
                    <a (click)="addSavedProperty()" class="button buy-button is-size-6 has-round-border"
                       style="border:none; display: block!important;">
                      <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                        <div class="column is-bold"><p style="padding-bottom: 10px">Objekt hinzufügen</p></div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="savedPropertyId !== 'new'" class="columns">
  <div class="column is-1"></div>
  <app-document-overview-last-order [savedPropertyId]="savedPropertyId"></app-document-overview-last-order>
  <div class="column is-1"></div>
</div>
